// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
export function authAdminChecker(stateAuthUserData: any) {
  const listCurrentAuth = stateAuthUserData.authorities.map((item: any) => item.name)

  return !!listCurrentAuth.includes('AUTH_ADMIN')
}

export function filterLocationList(
  defaultLocationList: any,
  stateAuthUserData: any,
  keyType = 'id', //
  config = {
    showDefaultList: false, /// SHOW default FOR OTHER THAN AUTH_ADMIN
  },
) {
  const listLocationFromAuth = stateAuthUserData.location_roles.map((item: any) => {
    let newObj: any
    if (keyType === 'id') {
      newObj = {
        id: item.location_id,
        name: item.location_name,
        type: item.location_type,
      }
    } else if (keyType === 'location_id') {
      // newObj = { ...item };
      newObj = {
        name: item.location_name,
        location_id: item.location_id,
        location_name: item.location_name,
        location_type: item.location_type,
      }
    }

    return newObj
  })

  if (authAdminChecker(stateAuthUserData)) {
    return defaultLocationList
  }
  if (config.showDefaultList) {
    return defaultLocationList
  }
  return listLocationFromAuth

  // return listLocationFromAuth;
}

export const getLocationIdByAccessRoleLocation = (userAuth: any, listLocationType: any[] = []) => {
  if (authAdminChecker(userAuth)) {
    return {
      locationId: '',
      type: listLocationType.toString(),
    }
  }

  const listLocation = userAuth.location_roles.filter((locationItem: any) =>
    listLocationType.includes(locationItem.location_type),
  )

  const locationIdList = listLocation.map((locationItem: any) => locationItem.location_id) || ''

  return {
    locationId: locationIdList.toString(),
    type: listLocationType.toString(),
  }
}

export function initialLocationQuery(
  // defaultLocationList,
  stateAuthUserData: any,
  withQuery = false,
  locationType: any = false,
  config = {
    showAll: false,
  },
  // keyType = "id"
): any {
  if (authAdminChecker(stateAuthUserData)) {
    return ``
  }
  if (config.showAll) {
    //
    return ``
  }
  if (withQuery === true) {
    if (locationType === 'HUB') {
      const tmpHubLoc = stateAuthUserData.location_roles.filter(
        (el: any) => el.location_type === 'HUB',
      )

      if (tmpHubLoc.length) return tmpHubLoc.map((tmpItemHub: any) => tmpItemHub.location_id)
      return ''
      //
    }
    if (locationType === 'WAREHOUSE') {
      //
      // console.log(tmpWarehouseLoc);

      return stateAuthUserData.location_roles.filter(
        (el: any) =>
          // console.log(el);
          el.location_type === 'WAREHOUSE',
      )
    }
    return stateAuthUserData.location_roles[0].location_id
  }
  return `&locationId=${stateAuthUserData.location_roles[0].location_id}`
}

export const roleUserChecker = (userData: any, listOfAllowedUser: any[] = []) => {
  /** *
   * CHECKING USER ROLE, IF LOGED USER ROLE EXIST / SAME WITH listOfAllowedUser
   * RETURN TRUE
   */
  const { authorities } = userData

  const currentUserAuth = authorities.map((items: any) => items.name)

  const findAllowedAccess = (arr1: any[], arr2: any[]) =>
    arr1.some((item: any) => arr2.includes(item))
  // console.log(listOfAllowedUser);
  // console.log(findAllowedAccess(currentUserAuth, listOfAllowedUser));
  return findAllowedAccess(listOfAllowedUser, currentUserAuth)
}

export function filterByUserLocationsList(
  defaultLocationList: any,
  stateAuthUserData: any,
  config = {
    showDefaultList: false, /// SHOW default FOR OTHER THAN AUTH_ADMIN
  },
) {
  const listUserLocationsFromAuth = stateAuthUserData.user_locations.map((item: any) => ({
    name: item.location_name,
    location_id: item.location_id,
    location_name: item.location_name,
    location_type: item.location_type,
  }))

  if (authAdminChecker(stateAuthUserData) || config.showDefaultList) {
    return defaultLocationList
  }
  return listUserLocationsFromAuth
}
